import { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';
import { storeToRefs } from 'pinia';
import { useLoaderAtStartStore } from '@/shared/components/loaders/LoaderAtStartApp/store';
import { useInviteStore } from '@/modules/invite/stores/invite';
import { InviteResponseStatusEnum } from '@/core/graphql/types';

export const inviteWelcomeRoute: RouteRecordRaw = {
  path: '/invite-welcome',
  name: AppScreens.InviteWelcome,
  component: () => import('@/modules/invite/views/InviteWelcome.vue'),
  meta: {
    layout: 'empty',
  },
  beforeEnter(to, from, next) {
    const { visible, loaderIsRequired } = storeToRefs(useLoaderAtStartStore());

    visible.value = false;
    loaderIsRequired.value = false;

    const inviteStore = useInviteStore();
    if (inviteStore.getClaimResult()?.status !== InviteResponseStatusEnum.PENDING) {
      next({
        name: AppScreens.Stories,
      });

      return;
    }

    next();
  },
};

export const inviteVillageRoute: RouteRecordRaw = {
  path: `/my-village`,
  name: AppScreens.InviteVillage,
  component: () => import('@/modules/invite/views/InviteVillage.vue'),
  meta: {
    layout: 'main',
  },
  beforeEnter() {
    const { visible, loaderIsRequired } = storeToRefs(useLoaderAtStartStore());

    visible.value = false;
    loaderIsRequired.value = false;
  },
};
